import { render } from "./TaxSettings.vue?vue&type=template&id=698ea4ce&scoped=true"
import script from "./TaxSettings.vue?vue&type=script&lang=js"
export * from "./TaxSettings.vue?vue&type=script&lang=js"

import "./TaxSettings.vue?vue&type=style&index=0&id=698ea4ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698ea4ce"]])

export default __exports__